export default [
  {
    path: "/customs",
    name: "customs",
    component: () => import("@/modules/customs/Customs.vue"),
    children: [
      {
        path: "list",
        name: "list-customs",
        component: () => import("@/modules/customs/pages/CustomsList.vue"),
        meta: { permissions: ["suppliers-show"] }
      },
      {
        path: "add",
        name: "add-customs",
        component: () => import("@/modules/customs/pages/CustomsAdd.vue"),
        meta: { permissions: ["suppliers-create"] }
      },
      {
        path: "edit/:id",
        name: "edit-customs",
        component: () => import("@/modules/customs/pages/CustomsEdit.vue"),
        meta: { permissions: ["suppliers-update"] }
      }
    ]
  }
];